<template>
  <div class="box-inner-body">
    <Form :model="awardData" :label-width="100">
      <FormItem label="奖品类型">
        <Select v-model="awardData.type">
          <Option :value="item.value" v-for="item in rsList" :key="item.value">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="奖品id:">
        <Row>
          <Col span="11">
          <Input v-model="awardData.rewardRelationId" placeholder="奖品Id"></Input>
          </Col>
          <Col span="2" style="text-align: center">
          </Col>
          <Col span="11">
          <Button type="success" @click="getSourceIcon">获取图标</Button>
          </Col>
        </Row>
      </FormItem>
      <FormItem label="奖品名称">
        <Row>
          <Col span="11">
          <Input v-model="awardData.rewardName" placeholder="获取图标后自动写入" :disabled="true"></Input>
          </Col>
          <Col span="2" style="text-align: center">
          </Col>
          <Col span="11">
          <div class="img-preview" v-if="!awardData.rewardIcon"></div>
          <img class="img-preview" :src="awardData.rewardIcon" v-else>
          </Col>
        </Row>
      </FormItem>
      <FormItem label="资源预览">
        <UploadSingleImg v-model="awardData.preUrl" :on-upload="newUploadImg"></UploadSingleImg>
      </FormItem>
      <FormItem label="角标">
        <RadioGroup v-model="awardData.mark">
          <Radio :label="0">无</Radio>
          <Radio :label="1">稀有</Radio>
          <Radio :label="2">新品</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="排序">
        <Input v-model="awardData.orderId" placeholder="请输入排序"></Input>
      </FormItem>
      <FormItem label="资源有效期">
        <InputNumber v-model="awardData.expire" controls-outside></InputNumber>
      </FormItem>
      <FormItem label="奖品价值">
        <Input v-model="awardData.price" placeholder="请输入价值"></Input>
      </FormItem>
      <FormItem label="展示价值">
        <Input v-model="awardData.showPrice" placeholder="请输入价值"></Input>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg.vue'
import { getResourceInfoReq } from "@/api/carnivalApi"
import { resourceList, getResourceName } from './data';
export default {
  components: {
    UploadSingleImg
  },
  props: {
    
    rsList: {
      type: Array,
      default: () => {
        return []
      }
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      resourceList
    }
  },
  methods: {
    getResourceName,
    selectResource(row) {
      this.awardData = { ...this.awardData, ...row };
    },

    async newUploadImg(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('cover', 0)
      formData.append('dir', 'starry/pre/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formData
      )
      return { code: res.code, url: res.data }
    },
    // 获取图标资源和名称
    async getSourceIcon() {

      const res = await getResourceInfoReq({
        rewardId: this.awardData.rewardRelationId,
        type: this.awardData.type,
      })
      if (res.code === 0 || res.status === 0) {
        this.$Message.success('success')
        this.awardData = { ...this.awardData, rewardIcon: res.data.rewardIcon, rewardName: res.data.rewardName, price: res.data.price || this.awardData.price }
      } else {
        this.$Message.error(res.msg || res.message)
      }
    },
  },
  computed: {
    awardData: {
      get() {
        let _this = this
        const proxy = new Proxy(this.value, {
          set(target, key, value) {
            _this.$emit('input', {
              ...target,
              [key]: value
            })
            return true
          },
          get(target, key) {
            return Reflect.get(target, key)
          }
        })
        return proxy
      },
      set(val) {
        this.$emit('input', val)
      }
    }

  }
}
</script>

<style scoped lang="scss">
.img-preview {
  width: 100px;
  height: 100px;
  object-fit: contain;
  border: 2px dashed #eee;
}

.box-inner-body {
  border: 2px dashed #eee;
  padding: 10px;
}
</style>